/**
 * Country list used by the phone field: ISO 3166-1 alpha-2 code, Portuguese
 * name and international dialling code (without the leading '+').
 *
 * The flag is not stored: it is derived from the ISO code by mapping each
 * letter to its regional indicator symbol (see `countryFlag`).
 */
export const COUNTRIES = [
    { code: 'AF', name: 'Afeganistão', dial: '93' },
    { code: 'ZA', name: 'África do Sul', dial: '27' },
    { code: 'AL', name: 'Albânia', dial: '355' },
    { code: 'DE', name: 'Alemanha', dial: '49' },
    { code: 'AD', name: 'Andorra', dial: '376' },
    { code: 'AO', name: 'Angola', dial: '244' },
    { code: 'AI', name: 'Anguilla', dial: '1264' },
    { code: 'AG', name: 'Antígua e Barbuda', dial: '1268' },
    { code: 'SA', name: 'Arábia Saudita', dial: '966' },
    { code: 'DZ', name: 'Argélia', dial: '213' },
    { code: 'AR', name: 'Argentina', dial: '54' },
    { code: 'AM', name: 'Armênia', dial: '374' },
    { code: 'AW', name: 'Aruba', dial: '297' },
    { code: 'AU', name: 'Austrália', dial: '61' },
    { code: 'AT', name: 'Áustria', dial: '43' },
    { code: 'AZ', name: 'Azerbaijão', dial: '994' },
    { code: 'BS', name: 'Bahamas', dial: '1242' },
    { code: 'BH', name: 'Bahrein', dial: '973' },
    { code: 'BD', name: 'Bangladesh', dial: '880' },
    { code: 'BB', name: 'Barbados', dial: '1246' },
    { code: 'BE', name: 'Bélgica', dial: '32' },
    { code: 'BZ', name: 'Belize', dial: '501' },
    { code: 'BJ', name: 'Benin', dial: '229' },
    { code: 'BM', name: 'Bermudas', dial: '1441' },
    { code: 'BY', name: 'Bielorrússia', dial: '375' },
    { code: 'BO', name: 'Bolívia', dial: '591' },
    { code: 'BA', name: 'Bósnia e Herzegovina', dial: '387' },
    { code: 'BW', name: 'Botsuana', dial: '267' },
    { code: 'BR', name: 'Brasil', dial: '55' },
    { code: 'BN', name: 'Brunei', dial: '673' },
    { code: 'BG', name: 'Bulgária', dial: '359' },
    { code: 'BF', name: 'Burkina Faso', dial: '226' },
    { code: 'BI', name: 'Burundi', dial: '257' },
    { code: 'BT', name: 'Butão', dial: '975' },
    { code: 'CV', name: 'Cabo Verde', dial: '238' },
    { code: 'CM', name: 'Camarões', dial: '237' },
    { code: 'KH', name: 'Camboja', dial: '855' },
    { code: 'CA', name: 'Canadá', dial: '1' },
    { code: 'QA', name: 'Catar', dial: '974' },
    { code: 'KZ', name: 'Cazaquistão', dial: '7' },
    { code: 'TD', name: 'Chade', dial: '235' },
    { code: 'CL', name: 'Chile', dial: '56' },
    { code: 'CN', name: 'China', dial: '86' },
    { code: 'CY', name: 'Chipre', dial: '357' },
    { code: 'SG', name: 'Cingapura', dial: '65' },
    { code: 'CO', name: 'Colômbia', dial: '57' },
    { code: 'KM', name: 'Comores', dial: '269' },
    { code: 'CG', name: 'Congo', dial: '242' },
    { code: 'CD', name: 'Congo (RDC)', dial: '243' },
    { code: 'KP', name: 'Coreia do Norte', dial: '850' },
    { code: 'KR', name: 'Coreia do Sul', dial: '82' },
    { code: 'CI', name: 'Costa do Marfim', dial: '225' },
    { code: 'CR', name: 'Costa Rica', dial: '506' },
    { code: 'HR', name: 'Croácia', dial: '385' },
    { code: 'CU', name: 'Cuba', dial: '53' },
    { code: 'CW', name: 'Curaçao', dial: '599' },
    { code: 'DK', name: 'Dinamarca', dial: '45' },
    { code: 'DJ', name: 'Djibuti', dial: '253' },
    { code: 'DM', name: 'Dominica', dial: '1767' },
    { code: 'EG', name: 'Egito', dial: '20' },
    { code: 'SV', name: 'El Salvador', dial: '503' },
    { code: 'AE', name: 'Emirados Árabes Unidos', dial: '971' },
    { code: 'EC', name: 'Equador', dial: '593' },
    { code: 'ER', name: 'Eritreia', dial: '291' },
    { code: 'SK', name: 'Eslováquia', dial: '421' },
    { code: 'SI', name: 'Eslovênia', dial: '386' },
    { code: 'ES', name: 'Espanha', dial: '34' },
    { code: 'US', name: 'Estados Unidos', dial: '1' },
    { code: 'EE', name: 'Estônia', dial: '372' },
    { code: 'SZ', name: 'Essuatíni', dial: '268' },
    { code: 'ET', name: 'Etiópia', dial: '251' },
    { code: 'FJ', name: 'Fiji', dial: '679' },
    { code: 'PH', name: 'Filipinas', dial: '63' },
    { code: 'FI', name: 'Finlândia', dial: '358' },
    { code: 'FR', name: 'França', dial: '33' },
    { code: 'GA', name: 'Gabão', dial: '241' },
    { code: 'GM', name: 'Gâmbia', dial: '220' },
    { code: 'GH', name: 'Gana', dial: '233' },
    { code: 'GE', name: 'Geórgia', dial: '995' },
    { code: 'GI', name: 'Gibraltar', dial: '350' },
    { code: 'GD', name: 'Granada', dial: '1473' },
    { code: 'GR', name: 'Grécia', dial: '30' },
    { code: 'GL', name: 'Groenlândia', dial: '299' },
    { code: 'GP', name: 'Guadalupe', dial: '590' },
    { code: 'GU', name: 'Guam', dial: '1671' },
    { code: 'GT', name: 'Guatemala', dial: '502' },
    { code: 'GG', name: 'Guernsey', dial: '44' },
    { code: 'GY', name: 'Guiana', dial: '592' },
    { code: 'GF', name: 'Guiana Francesa', dial: '594' },
    { code: 'GN', name: 'Guiné', dial: '224' },
    { code: 'GQ', name: 'Guiné Equatorial', dial: '240' },
    { code: 'GW', name: 'Guiné-Bissau', dial: '245' },
    { code: 'HT', name: 'Haiti', dial: '509' },
    { code: 'NL', name: 'Holanda', dial: '31' },
    { code: 'HN', name: 'Honduras', dial: '504' },
    { code: 'HK', name: 'Hong Kong', dial: '852' },
    { code: 'HU', name: 'Hungria', dial: '36' },
    { code: 'YE', name: 'Iêmen', dial: '967' },
    { code: 'IN', name: 'Índia', dial: '91' },
    { code: 'ID', name: 'Indonésia', dial: '62' },
    { code: 'IR', name: 'Irã', dial: '98' },
    { code: 'IQ', name: 'Iraque', dial: '964' },
    { code: 'IE', name: 'Irlanda', dial: '353' },
    { code: 'IS', name: 'Islândia', dial: '354' },
    { code: 'IL', name: 'Israel', dial: '972' },
    { code: 'IT', name: 'Itália', dial: '39' },
    { code: 'JM', name: 'Jamaica', dial: '1876' },
    { code: 'JP', name: 'Japão', dial: '81' },
    { code: 'JE', name: 'Jersey', dial: '44' },
    { code: 'JO', name: 'Jordânia', dial: '962' },
    { code: 'KW', name: 'Kuwait', dial: '965' },
    { code: 'LA', name: 'Laos', dial: '856' },
    { code: 'LS', name: 'Lesoto', dial: '266' },
    { code: 'LV', name: 'Letônia', dial: '371' },
    { code: 'LB', name: 'Líbano', dial: '961' },
    { code: 'LR', name: 'Libéria', dial: '231' },
    { code: 'LY', name: 'Líbia', dial: '218' },
    { code: 'LI', name: 'Liechtenstein', dial: '423' },
    { code: 'LT', name: 'Lituânia', dial: '370' },
    { code: 'LU', name: 'Luxemburgo', dial: '352' },
    { code: 'MO', name: 'Macau', dial: '853' },
    { code: 'MK', name: 'Macedônia do Norte', dial: '389' },
    { code: 'MG', name: 'Madagascar', dial: '261' },
    { code: 'MY', name: 'Malásia', dial: '60' },
    { code: 'MW', name: 'Malaui', dial: '265' },
    { code: 'MV', name: 'Maldivas', dial: '960' },
    { code: 'ML', name: 'Mali', dial: '223' },
    { code: 'MT', name: 'Malta', dial: '356' },
    { code: 'MA', name: 'Marrocos', dial: '212' },
    { code: 'MQ', name: 'Martinica', dial: '596' },
    { code: 'MU', name: 'Maurício', dial: '230' },
    { code: 'MR', name: 'Mauritânia', dial: '222' },
    { code: 'MX', name: 'México', dial: '52' },
    { code: 'MM', name: 'Mianmar', dial: '95' },
    { code: 'FM', name: 'Micronésia', dial: '691' },
    { code: 'MZ', name: 'Moçambique', dial: '258' },
    { code: 'MD', name: 'Moldávia', dial: '373' },
    { code: 'MC', name: 'Mônaco', dial: '377' },
    { code: 'MN', name: 'Mongólia', dial: '976' },
    { code: 'ME', name: 'Montenegro', dial: '382' },
    { code: 'NA', name: 'Namíbia', dial: '264' },
    { code: 'NP', name: 'Nepal', dial: '977' },
    { code: 'NI', name: 'Nicarágua', dial: '505' },
    { code: 'NE', name: 'Níger', dial: '227' },
    { code: 'NG', name: 'Nigéria', dial: '234' },
    { code: 'NO', name: 'Noruega', dial: '47' },
    { code: 'NC', name: 'Nova Caledônia', dial: '687' },
    { code: 'NZ', name: 'Nova Zelândia', dial: '64' },
    { code: 'OM', name: 'Omã', dial: '968' },
    { code: 'PW', name: 'Palau', dial: '680' },
    { code: 'PS', name: 'Palestina', dial: '970' },
    { code: 'PA', name: 'Panamá', dial: '507' },
    { code: 'PG', name: 'Papua-Nova Guiné', dial: '675' },
    { code: 'PK', name: 'Paquistão', dial: '92' },
    { code: 'PY', name: 'Paraguai', dial: '595' },
    { code: 'PE', name: 'Peru', dial: '51' },
    { code: 'PF', name: 'Polinésia Francesa', dial: '689' },
    { code: 'PL', name: 'Polônia', dial: '48' },
    { code: 'PR', name: 'Porto Rico', dial: '1787' },
    { code: 'PT', name: 'Portugal', dial: '351' },
    { code: 'KE', name: 'Quênia', dial: '254' },
    { code: 'KG', name: 'Quirguistão', dial: '996' },
    { code: 'GB', name: 'Reino Unido', dial: '44' },
    { code: 'CF', name: 'República Centro-Africana', dial: '236' },
    { code: 'DO', name: 'República Dominicana', dial: '1809' },
    { code: 'CZ', name: 'República Tcheca', dial: '420' },
    { code: 'RE', name: 'Reunião', dial: '262' },
    { code: 'RO', name: 'Romênia', dial: '40' },
    { code: 'RW', name: 'Ruanda', dial: '250' },
    { code: 'RU', name: 'Rússia', dial: '7' },
    { code: 'EH', name: 'Saara Ocidental', dial: '212' },
    { code: 'WS', name: 'Samoa', dial: '685' },
    { code: 'AS', name: 'Samoa Americana', dial: '1684' },
    { code: 'SM', name: 'San Marino', dial: '378' },
    { code: 'SH', name: 'Santa Helena', dial: '290' },
    { code: 'LC', name: 'Santa Lúcia', dial: '1758' },
    { code: 'BL', name: 'São Bartolomeu', dial: '590' },
    { code: 'KN', name: 'São Cristóvão e Névis', dial: '1869' },
    { code: 'MF', name: 'São Martinho', dial: '590' },
    { code: 'ST', name: 'São Tomé e Príncipe', dial: '239' },
    { code: 'VC', name: 'São Vicente e Granadinas', dial: '1784' },
    { code: 'SC', name: 'Seicheles', dial: '248' },
    { code: 'SN', name: 'Senegal', dial: '221' },
    { code: 'SL', name: 'Serra Leoa', dial: '232' },
    { code: 'RS', name: 'Sérvia', dial: '381' },
    { code: 'SY', name: 'Síria', dial: '963' },
    { code: 'SO', name: 'Somália', dial: '252' },
    { code: 'LK', name: 'Sri Lanka', dial: '94' },
    { code: 'SD', name: 'Sudão', dial: '249' },
    { code: 'SS', name: 'Sudão do Sul', dial: '211' },
    { code: 'SE', name: 'Suécia', dial: '46' },
    { code: 'CH', name: 'Suíça', dial: '41' },
    { code: 'SR', name: 'Suriname', dial: '597' },
    { code: 'TJ', name: 'Tajiquistão', dial: '992' },
    { code: 'TH', name: 'Tailândia', dial: '66' },
    { code: 'TW', name: 'Taiwan', dial: '886' },
    { code: 'TZ', name: 'Tanzânia', dial: '255' },
    { code: 'TL', name: 'Timor-Leste', dial: '670' },
    { code: 'TG', name: 'Togo', dial: '228' },
    { code: 'TO', name: 'Tonga', dial: '676' },
    { code: 'TT', name: 'Trinidad e Tobago', dial: '1868' },
    { code: 'TN', name: 'Tunísia', dial: '216' },
    { code: 'TM', name: 'Turcomenistão', dial: '993' },
    { code: 'TR', name: 'Turquia', dial: '90' },
    { code: 'UA', name: 'Ucrânia', dial: '380' },
    { code: 'UG', name: 'Uganda', dial: '256' },
    { code: 'UY', name: 'Uruguai', dial: '598' },
    { code: 'UZ', name: 'Uzbequistão', dial: '998' },
    { code: 'VU', name: 'Vanuatu', dial: '678' },
    { code: 'VA', name: 'Vaticano', dial: '379' },
    { code: 'VE', name: 'Venezuela', dial: '58' },
    { code: 'VN', name: 'Vietnã', dial: '84' },
    { code: 'ZM', name: 'Zâmbia', dial: '260' },
    { code: 'ZW', name: 'Zimbábue', dial: '263' }
];

export const DEFAULT_COUNTRY_CODE = 'BR';

/** Emoji flag for an ISO 3166-1 alpha-2 code (e.g. 'BR' -> 🇧🇷). */
export function countryFlag(code) {
    if (!code || code.length !== 2) return '';

    return String.fromCodePoint(...code
        .toUpperCase()
        .split('')
        .map(char => 0x1F1E6 + char.charCodeAt(0) - 65));
}

export function getCountryByCode(code) {
    return COUNTRIES.find(country => country.code === code);
}

/**
 * Countries that share a dialling code with others: the one an E.164 number
 * should be attributed to when the code alone cannot tell them apart (e.g. '1'
 * is both the United States and Canada).
 */
const PREFERRED_BY_DIAL = {
    '1': 'US',
    '7': 'RU',
    '44': 'GB',
    '212': 'MA',
    '590': 'GP'
};

/**
 * Splits a stored E.164 number (e.g. '+5511999991234') into the country it
 * belongs to and the national number. The longest matching dialling code wins,
 * so the NANP codes ('+1876') are preferred over the plain '+1'.
 *
 * Returns the default country and an empty number when there is nothing to
 * parse, and the default country with the whole number when it carries no
 * dialling code or none matches.
 */
export function parsePhoneNumber(phoneNumber) {
    const value = phoneNumber || '';
    const digits = value.replace(/\D/g, '');

    if (!digits) {
        return { countryCode: DEFAULT_COUNTRY_CODE, nationalNumber: '' };
    }

    // Legacy records hold a national number with no dialling code at all: they
    // are all Brazilian, since that was the only code accepted back then.
    if (!value.trim().startsWith('+')) {
        return { countryCode: DEFAULT_COUNTRY_CODE, nationalNumber: digits };
    }

    const matches = COUNTRIES
        .filter(country => digits.startsWith(country.dial))
        .sort((a, b) => b.dial.length - a.dial.length);

    if (!matches.length) {
        return { countryCode: DEFAULT_COUNTRY_CODE, nationalNumber: digits };
    }

    const longestDial = matches[0].dial;
    const preferredCode = PREFERRED_BY_DIAL[longestDial];
    const country = matches.find(match => match.dial === longestDial && match.code === preferredCode) || matches[0];

    return { countryCode: country.code, nationalNumber: digits.slice(country.dial.length) };
}

/** Joins a country code and a national number back into an E.164 string. */
export function formatPhoneNumber(countryCode, nationalNumber) {
    const digits = (nationalNumber || '').replace(/\D/g, '');
    const country = getCountryByCode(countryCode) || getCountryByCode(DEFAULT_COUNTRY_CODE);

    return digits ? '+' + country.dial + digits : '';
}
